// Cursor handled via CSS (cyan SVG arrow). This component is intentionally empty.
export default function CursorGlow() {
  return null;
}
